/* 🤖 this file was generated by svg-to-ts */
export const matIconDrafts: {
  name: 'drafts';
  data: string;
} = {
  name: 'drafts',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zm-2 0v.01L12 13 4 8l8-4.68L19.99 8zM4 18v-7.66l8 5.02 7.99-4.99L20 18H4z"/></svg>`
};
